import React from 'react';
import ReactDOM from 'react-dom';
import Navigator from './Navigator';
import './index.css';

ReactDOM.render(
  <React.StrictMode>
    <Navigator />
  </React.StrictMode>,
  document.getElementById('root')
);
